import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { AgeVerificationPopup } from './AgeVerificationPopup';
import uuid from 'uuid-random';

const ageVerificationId = uuid();

export const showAgeVerificationPopupAction = ({ onClose } = {}) => addPopupAction({
    id: ageVerificationId,
    component: AgeVerificationPopup,
    layer: LAYER.COMMON,
    onClose,
    isModal: true
});
